'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Dashboard$Selectors(host, user) {
  this.JA = null;
  this.JB = null;
  this.JA = host;
  this.JB = user;
}
export { $c_Lpresto_Dashboard$Selectors as $c_Lpresto_Dashboard$Selectors };
$p = $c_Lpresto_Dashboard$Selectors.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Dashboard$Selectors;
/** @constructor */
function $h_Lpresto_Dashboard$Selectors() {
}
export { $h_Lpresto_Dashboard$Selectors as $h_Lpresto_Dashboard$Selectors };
$h_Lpresto_Dashboard$Selectors.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Dashboard$Selectors)) {
    var x = this.JA;
    var x$2 = x$0.JA;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.JB;
      var x$4 = x$0.JB;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "Selectors";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.JA;
  }
  if ((n === 1)) {
    return this.JB;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_Dashboard$Selectors(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i5)));
}
export { $isArrayOf_Lpresto_Dashboard$Selectors as $isArrayOf_Lpresto_Dashboard$Selectors };
var $d_Lpresto_Dashboard$Selectors = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Dashboard$Selectors, "presto.Dashboard$Selectors", ({
  i5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Dashboard$Selectors as $d_Lpresto_Dashboard$Selectors };
//# sourceMappingURL=presto.-Dashboard$-Selectors.js.map
